export default {productName:'Beey',company:{name:'NEWTON Technologies',webpage:'https://www.beey.io/about-beey'}}